/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RepliesIcon = ({ width = 24, height = 24, hidden = false, title = 'Replies' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M21.947 6.059V2.878a.636.636 0 0 0-1.086-.45l-7.187 7.449 7.186 7.449a.636.636 0 0 0 1.086-.45v-3.229a11.687 11.687 0 0 1 11.916 4.632.45.45 0 0 0 .811-.26c.001-1.919-2.191-11.96-12.726-11.96ZM11.975 18v-3.749a.75.75 0 0 0-1.28-.53L2.225 22.5l8.47 8.779a.75.75 0 0 0 1.28-.53v-3.8A13.773 13.773 0 0 1 26.019 32.4a.531.531 0 0 0 .956-.307c0-2.261-2.584-14.093-15-14.093Z"
    />
  </svg>`;
};
